import { Box } from '@factorialco/deprecated-design-system'
import { FileSigned } from '@factorialco/f0-react/icons/app'
import { ExpenseDetailPageQuery } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import LegalComplianceSection from 'modules/expenses/pages/settings/Content/LegalCompliance'
import SectionInfo from 'modules/expenses/pages/settings/ExpensePolicy/Components/_SectionInfo'

type ExpensesSignedDocumentsTerm = NonNullable<
  NonNullable<ExpenseDetailPageQuery['expenses']['signedDocumentsTermsConnection']>['nodes']
>[number]

interface Props {
  signedDocumentsTerms: ExpensesSignedDocumentsTerm[]
}

const DigitalCertifiedDocuments = ({ signedDocumentsTerms }: Props) => {
  return (
    <Box flexDirection="column" gap="s24" paddingX="s24" flexGrow>
      <SectionInfo
        icon={FileSigned}
        title={i18n.t('expenses.settings.legal_compliance.title_v2')}
        description={i18n.t('expenses.settings.legal_compliance.description_v2')}
      />

      <LegalComplianceSection signedDocumentsTerms={signedDocumentsTerms} hideTitle />
    </Box>
  )
}

export default DigitalCertifiedDocuments
